<template>
  <div>
    <nav-menu v-if="tela_cheia"></nav-menu>

    <empresas-autorizadas
      ref="frEmpresas"
      @click="this.$forceUpdate();"
      @pegarIdEmpresas="pegandoIdEmpresas"
      :c_local_storage_empresa="c_local_storage_empresa"/>

    <div class="w3-row w3-container">
      <div class="w3-block w3-text-theme w3-margin-top">
        <div class="w3-col s12 m8 l9">
          <h4>
            <i class="fas fa-poll"></i>
            <span> Acompanhamento de Vendas</span>
          </h4>
        </div>

        <div class="w3-col s12 m4 l3 w3-right periodo w3-padding-small w3-center">
          <strong style="color: black; align: center">
            <label>{{getPeriodo}}</label>
          </strong>
        </div>
      </div>
    </div>
    
    <h6
      v-if="!mostrar_empresas"
      class="w3-text-theme w3-padding-small">&nbsp;
      <i class="fas fa-caret-right"></i>&nbsp;      
      <a
        style="text-decoration: underline; cursor: pointer;"
        @click="mostrar_empresas = true">
        <span>Empresas selecionadas</span>
      </a>&nbsp;

      <span
        style="text-decoration: underline; cursor: pointer;"
        @click="$refs.frEmpresas.definirEmpresas(false)">
        <span>(Alterar)</span>
      </span>
    </h6> 

    <h6
      v-if="mostrar_empresas && existemValores()"
      class="w3-text-theme w3-padding-small">&nbsp;
      <i class="fas fa-caret-down"></i>&nbsp;
      <a
        style="text-decoration: underline; cursor: pointer;"
        @click="mostrar_empresas = false">
        <span>Empresas selecionadas</span>
      </a>&nbsp;

      <span
        style="text-decoration: underline; cursor: pointer;"
        @click="$refs.frEmpresas.definirEmpresas(false)">
        <span>(Alterar)</span>
      </span>
    </h6>

    <div class="w3-padding">
      <div
        v-if="mostrar_empresas"
        class="w3-conteiner w3-border w3-padding w3-animate-zoom empresas-selecionadas">
        <span>{{getEmpresasSelecionadas}}</span>
      </div>
    </div>

    <div class="w3-col s12 m12 l12" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div
      class="w3-col s12 m12 l12 w3-padding-small w3-margin-top"
      v-if="tela_cheia && !processando">

      <div class="w3-col s4 m2 l2">
        <button
          class="botao-tipo-pesquisa"
          :class="classe_botao_dia_anterior"
          @click="alterarTipoPesquisa('ANT')">
          <span>Ontem</span>
        </button>
      </div>

      <div class="w3-col s4 m2 l2">
        <button
          class="botao-tipo-pesquisa"
          :class="classe_botao_dia_atual"
          @click="alterarTipoPesquisa('HOJ')">
          <span>Hoje</span>
        </button>
      </div>

      <div class="w3-col s4 m2 l2">
        <button
          class="botao-tipo-pesquisa"
          :class="classe_botao_periodo"
          @click="alterarTipoPesquisa('PER')">
          <span>Período</span>
        </button>
      </div>
  
      <div class="w3-hide-small w3-col l2 w3-right">
        <button class="w3-button w3-right" @click="modoTelaCheia()">
          <i class="far fa-object-ungroup"></i>
        </button>
      </div>
    </div>

    <div
      class="animacao-div"
      v-if="(!processando) && tela_cheia && mostrar_filtro_periodo && mostrar_filtros">

      <div class="w3-col s12 m12 l12 w3-padding-small">
        <div class="w3-col s12 m12 l12">
          <strong>Período</strong>
        </div>

        <div class="w3-col s12 m3 l2 w3-padding-small" style="padding: 0px 5px 5px 0px !important">
          <input class="w3-input w3-border" id ="data_inicial" type="date" v-model="data_inicial"/>
        </div>

        <div class="w3-col s12 m3 l2 w3-padding-small" style="padding: 0px 5px 5px 0px !important">
          <input
            class="w3-input w3-border"
            id="data_final"
            type="date"
            v-model="data_final"/>
        </div>

        <button
          class="w3-button w3-theme w3-col s12 m4 l2 w3-padding w3-left"
          @click="buscarAcompanhamentoVendas(false)">
          <i class="fa fa-play-circle"></i>
          <span> Processar</span>
        </button>
      </div>

      <div
        v-if="(
          (!processando) &&
          (dados_vendas.length > 0) &&
          (mostrar_filtros) &&
          (tipo_pesquisa =='PER')
        )"
        class="w3-col s12 m12 s12 w3-center"
        style="margin-top: 1px;">

        <i
          @click="mostrar_filtros = false"
          class='fas fa-caret-up'
          style='font-size:24px; cursor: pointer;'>
        </i>
      </div>
    </div>

    <div class="w3-padding-small">
      <button
        class="w3-button w3-white w3-border w3-col "
        style="padding: 10px !important"
        v-if="tela_cheia && (!processando) && (!mostrar_filtros) && (tipo_pesquisa == 'PER')"
        v-on:click="mostrar_filtros = !mostrar_filtros">
        <i class="fa fa-filter icone-vermelho"></i> 
        <span>Alterar período</span>
      </button>
    </div>

    <div class="w3-padding-small">
      <div
        v-if="(!processando) && (!existemValores())"
        class="w3-padding w3-col card-itens w3-margin-top w3-border">
        <span>Nenhum dado encontrado.</span>
      </div>
    </div>

    <div v-show="!processando">
      <div class="w3-container menu-tab" style="padding:0px 8px">
        <div v-show="existemValores()" class="w3-bar w3-white w3-border">

          <div class="w3-col s6 m6">
            <button
              id="Botaodados"
              class="w3-bar-item w3-theme-inverse-black tablink tab-active active botao-quadrado"
              style="width: 100%;padding:8px 0px"
              v-on:click="trocarAba('Botaodados', 'D')"
              ref="botaoDados">
              <i class="fa fa fa-table"></i>
            </button>
          </div>

          <div class="w3-col s6 m6">
            <button
              id="Botaograficos"
              class="w3-bar-item w3-theme-inverse-black tablink tab-active botao-quadrado"
              style="width: 100%;padding:8px 0px"
              v-on:click="trocarAba('Botaograficos','G')"
              ref="botaoGrafico">
              <i class="fas fa-chart-bar"></i>
            </button>
          </div>
        </div>
      </div>

      <div v-if="existemValores()" style="padding: 10px;">
        <div class="w3-col w3-border" style="border-radius: 15px;padding: 10px;">
          <div class="w3-col">
            <span class="w3-left">Total geral vendas: </span>
            <strong class="w3-text-green w3-right">
              <span>{{nPadraoReais(total_geral_vendas)}}</span>
            </strong>
          </div>

          <div class="w3-col">
            <span class="w3-left">Total geral devoluções: </span>
            <strong class="w3-text-red w3-right">
              <span>{{nPadraoReais(total_geral_devolucoes)}}</span>
            </strong>
          </div>

          <div class="w3-col">
            <span class="w3-left">Total geral vendas liquidas: </span>
            <strong class="w3-text-green w3-right">
              <span>{{nPadraoReais(total_geral_vendas_liquidas)}}</span>
            </strong>
          </div>
        </div>
      </div>

      <div
        id="dados"
        class="aba w3-animate-left"
        v-show="existemValores()"
        v-if="(!processando) && (aba_selecionada == 'D')">

        <div
          class="w3-padding-small w3-col"
          id="div-tabela"
          :class="class_div_tabela"
          v-if="(!processando) && (dados_vendas)">

          <table class="w3-hide-small w3-table-all" id="table-dados">
            <thead>
              <tr>
                <th class="alinhamento-texto">Empresa</th>
                <th class="alinhamento-numero">Vendas</th>
                <th class="alinhamento-numero">Devoluções</th>
                <th class="alinhamento-numero">Vendas líquidas</th>
                <th v-if="mostrar_previsao" class="alinhamento-numero">Previsão de vendas</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="dados in dados_vendas" :key=dados.empresa_id>
                <td>{{dados.empresa_id}} - {{dados.nome_resumido_empresa}}</td>
                <td class="alinhamento-numero">{{dados.vendas}}</td>          
                <td class="alinhamento-numero">{{dados.devolucoes}}</td>
                <td class="alinhamento-numero">{{dados.valor_liquido}}</td>
                
                <td v-if="mostrar_previsao" class="alinhamento-numero">
                  <span>{{dados.previsao_vendas}}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="tela_cheia">
            <div
              v-show="parseFloat(dados.vendas) > 0 || parseFloat(dados.devolucoes) > 0"
              class="w3-hide-large w3-hide-medium card-vendas w3-margin-bottom w3-col"
              v-for="dados in dados_vendas" :key="dados.empresa_id">

              <div class="w3-col s12">
                <strong class="w3-left">
                  <span>{{dados.empresa_id}} - {{dados.nome_resumido_empresa}}</span>
                </strong>
              </div>

              <div class="w3-col s12">
                <label>Vendas </label>
                <strong class="w3-right">{{dados.vendas}}</strong>
              </div>

              <div class="w3-col s12">
                <label>Devoluções </label>
                <strong class="w3-right">{{dados.devolucoes}}</strong>
              </div>

              <div class="w3-col s12">
                <label>Vendas líquidas </label>
                <strong class="w3-right">{{dados.valor_liquido}}</strong>
              </div>

              <div class="w3-col s12">
                <label v-if="mostrar_previsao">Previsão de vendas </label>
                <strong v-if="mostrar_previsao" class="w3-right">
                  <span>{{dados.previsao_vendas}}</span>
                </strong>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div
        id="graficos"
        class="w3-animate-left"
        v-if="(!processando) && (aba_selecionada == 'G') && existemValores()"> 

        <VueApexCharts
          type=line
          height="450"
          :options="opcoes_grafico"
          :series="series_vendas_devolucoes">
        </VueApexCharts>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import toastr from 'toastr'
  import { setInterval } from 'timers'
  import VueNumeric from 'vue-numeric'
  import NavMenu from '@/components/Menu'
  import VueApexCharts from 'vue-apexcharts'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import EmpresasAutorizadas from '@/components/EmpresasAutorizadas'
  import RRelacaoAcompanhamentoVendas from '@/components/Rest/RRelacaoAcompanhamentoVendas.js'

  export default {
    name: 'AcompanhamentoVendas',       
    components: {
      VueNumeric, 
      NavMenu,
      VueApexCharts,
      EmpresasAutorizadas
    },

    mixins:[Biblioteca],

    data() {
      return {
        /* Verificado */
        mostrar_empresas : false,


        data_inicial: undefined,
        data_final: undefined,

        ultima_data_inicio: undefined,
        ultima_data_final: undefined,

        processando: false,
        mostrar_filtros: true,
        mostrar_previsao: false,

        dados_vendas: [],
        
        classe_botao_dia_anterior: '',
        classe_botao_dia_atual: 'botao-tipo-pesquisa-selecionado',
        classe_botao_periodo: '',

        tela_cheia: true,
        mostrar_periodo: false,
        mostrar_filtro_periodo: false,

        empresas_ids: [],
        tipo_pesquisa: 'HOJ',
        class_div_tabela: '',

        vendas: [],
        devolucoes: [],
        vendas_liquidas: [],
        
        c_local_storage_empresa: 'Empresas acompanhamento de vendas',

        botao: undefined,
        
        total_geral: 0,
        total_geral_vendas: 0,
        total_geral_devolucoes: 0,
        total_geral_vendas_liquidas: 0,
  
        opcoes_grafico: {},      
        
        texto_data_filtrada: '',
        series_vendas_devolucoes: [],

        aba_selecionada: 'D'
      }
    },
    
    computed: {
      getPeriodo() {
        let data_1 = Biblioteca.strToDate(this.data_inicial);
        let data_2 = Biblioteca.strToDate(this.data_final);

        if ((data_1 instanceof Date) && (data_2 instanceof Date)) {
          if (Biblioteca.fData(data_1) == Biblioteca.fData(data_2)) {
            return Biblioteca.fData(data_1);
          }

          if (data_1.getTime() < data_2.getTime()) {
            return Biblioteca.fData(data_1) + ' até ' + Biblioteca.fData(data_2);
          }
        }

        return '';
      },

      verificandoValor(dados_valor) {
        dados_valor = Biblioteca.valor(dados_valor);
        return dados_valor;
      },
      
      getEmpresasSelecionadas() {
        let retorno = '';
        for (let i = 0; i < this.dados_vendas.length; i++) {
          if (retorno != '') {
            retorno += ' / ';
          } 
          retorno += (
            this.dados_vendas[i].empresa_id + 
            ' - ' + 
            this.dados_vendas[i].nome_resumido_empresa
          );
        }

        if (retorno == '') {
          return 'Nenhuma empresa foi selecionada.';
        }
        
        else {
          return retorno;
        }
      }
    },

    methods: {
      pegandoIdEmpresas(ids) {
        this.empresas_ids = ids;
        this.buscarAcompanhamentoVendas(false);
      },

      async buscarAcompanhamentoVendas(automatico) {
        try {
          if (this.empresas_ids.length <= 0) {
            return;
          }

          if (!Biblioteca.validarPeriodo(this.data_inicial, this.data_final)) {
            this.processando = false;
            return;
          }

          if (!automatico) {
            this.processando = true;
            this.dados_vendas = [];
          }

          if (this.tipo_pesquisa == 'PER') {
            this.ultima_data_inicio = this.data_inicial;
            this.ultima_data_final = this.data_final;
          }

          this.mostrar_previsao = (this.tipo_pesquisa == 'HOJ');

          let data_hora_atual  = new Date();

          let dados_ultima_pesquisa = JSON.parse(
            localStorage.getItem(
              this.getLocalStorageId(
                this.data_inicial,
                this.data_final,
                this.empresas_ids
              )
            )
          );

          if (dados_ultima_pesquisa) {
            let data_ultima_pesquisa = moment(dados_ultima_pesquisa.data_hora_ultima_pesquisa, 'YYYYMMDD hh:mm');
            
            let diferenca = Math.abs(data_ultima_pesquisa.diff(data_hora_atual, 'minutes'));
            if (diferenca < 1) {
              this.dados_vendas = dados_ultima_pesquisa.dados;
              if (this.tipo_pesquisa == 'PER') {
                this.mostrar_filtros = (this.dados_vendas.length == 0);
              }

              this.processando = false;
              this.criarGrafico();
              return;
            }
          }

          let parametros = {
            data_inicial: Biblioteca.fData(this.data_inicial),
            data_final: Biblioteca.fData(this.data_final),
            empresas_ids:  this.empresas_ids
          };

          let retorno = await RRelacaoAcompanhamentoVendas.buscarAcompanhamentoVendas(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.dados_vendas = JSON.parse(JSON.stringify(retorno.dados.dados_vendas));
          if (this.tipo_pesquisa == 'PER') {
            this.mostrar_filtros = (this.dados_vendas.length == 0);
          }

          this.total_geral_vendas = Biblioteca.valor(retorno.dados.total_vendas);
          this.total_geral_vendas_liquidas  = Biblioteca.valor(retorno.dados.total_liquido);
          this.total_geral_devolucoes = Biblioteca.valor(retorno.dados.total_devolucoes);

          this.criarGrafico();

          localStorage.setItem(
            this.getLocalStorageId(
              this.data_inicial,
              this.data_final,
              this.empresas_ids
            ),
            JSON.stringify(
              {
                data_hora_ultima_pesquisa: moment().format('YYYYMMDD hh:mm'),
                tipo_pesquisa: this.tipo_pesquisa,
                dados: this.dados_vendas,
              }
            )
          );

          if (this.aba_selecionada == 'D') {
            this.trocarAba('Botaodados', this.aba_selecionada);
          }
          else {
            this.trocarAba('Botaograficos', this.aba_selecionada);
          }

          this.processando = false;
        }
        catch (error) {
          this.processando = false;
          toastr.error(error.message);
        }
      },

      alterarTipoPesquisa(filtro) {      
        if ((filtro == 'PER') && (this.ultima_data_final)) {
          this.data_inicial = this.ultima_data_inicio;
          this.data_final = this.ultima_data_final;
        }

        this.mostrar_filtro_periodo = false;

        this.classe_botao_dia_anterior =  '';
        this.classe_botao_dia_atual = '';
        this.classe_botao_periodo = '';
        this.tipo_pesquisa = filtro;

        if (filtro == 'ANT') {
          this.classe_botao_dia_anterior = 'botao-tipo-pesquisa-selecionado';
          this.data_final = moment().subtract(1, 'days').format('YYYY-MM-DD');
          this.data_inicial = this.data_final;
          
          this.buscarAcompanhamentoVendas(false);
        }
        else if (filtro == 'HOJ') {
          this.classe_botao_dia_atual = 'botao-tipo-pesquisa-selecionado';
          this.data_final = moment().format('YYYY-MM-DD');
          this.data_inicial = this.data_final;
          this.buscarAcompanhamentoVendas(false);
        }
        else if (filtro == 'PER') {
          this.classe_botao_periodo = 'botao-tipo-pesquisa-selecionado';
          this.mostrar_filtro_periodo = true;
        }
      },

      modoTelaCheia() {
        this.class_div_tabela = 'div-tela-cheia';
        let elem = document.documentElement;

        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
      },

      criarGrafico() {
        const corVendas = '#0fdbac';
        const corDevolucoes = '#db0f49';
        const corVendaLiquida = '#5e49e6';
        const corPrevisao = '#66ccff';

        let cores_grafico = [corVendas, corDevolucoes, corVendaLiquida];

        if (this.mostrar_previsao) {
          cores_grafico.push(corPrevisao);
        }

        let empresas =[];
        for (let i = 0; i < this.dados_vendas.length; i++) {
          if (
            (Biblioteca.valor(this.dados_vendas[i].vendas) > 0) || 
            (Biblioteca.valor(this.dados_vendas[i].vendas) > 0) 
          ) {
            empresas.push(
              this.dados_vendas[i].empresa_id +
              ' - ' +
              this.dados_vendas[i].nome_resumido_empresa
            );
          }
        }

        this.opcoes_grafico = {
         chart: {
            type: 'line',
            dropShadow: {
              enabled: true,
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },

          colors: cores_grafico,

          markers: {
            size: 10,
            shape: 'circle',
          },

          dataLabels: {
            enabled: false,
            style: {
              fontSize: '15px',
              colors: ['#4d4d4d'],
            },

            formatter: function(val) {
              return 'R$ '+ Biblioteca.nPadrao(val, 2)
            }
          },

          title: {
            text: undefined
          },

          xaxis: {
            categories: empresas,
            labels: {
              formatter: function (val) {
                return 'R$ '+ Biblioteca.nPadrao(val, 2)
              }
            }
          },

          yaxis: {
            title: {
              text: undefined
            },
          },

          tooltip: {
            y: {
              formatter: function (val) {
                return Biblioteca.nPadrao(val, 2)
              }
            }
          },

          fill: {
            opacity: 1
          },

          legend: {
            position: 'bottom',
            horizontalAlign: 'left',
            offsetX: 40
          }
        }

        let dados_colunas_vendas_devolucoes = [];
        let dados_colunas_vendas_liquidas_prev = [];

        let dado_empresa_vendas = {};

        dado_empresa_vendas.name = 'Vendas';
        dado_empresa_vendas.data = [];

        for (let i = 0; i < this.dados_vendas.length; i++) {
          dado_empresa_vendas.data.push(this.dados_vendas[i].vendas);
        }

        dados_colunas_vendas_devolucoes.push(dado_empresa_vendas);

        let dado_empresa_devolucoes = {};
        dado_empresa_devolucoes.name = 'Devoluções';
        dado_empresa_devolucoes.data = [];

        for (let i = 0; i < this.dados_vendas.length; i++) {
          dado_empresa_devolucoes.data.push(this.dados_vendas[i].devolucoes);
        }
        dados_colunas_vendas_devolucoes.push(dado_empresa_devolucoes);

        /*Venda liquida*/
        let dado_empresa_venda_liquida = {};
        dado_empresa_venda_liquida.name = 'Vendas líquidas';
        dado_empresa_venda_liquida.data = [];

        for (let i = 0; i < this.dados_vendas.length; i++) {
          dado_empresa_venda_liquida.data.push(this.dados_vendas[i].valor_liquido);
        }
        dados_colunas_vendas_devolucoes.push(dado_empresa_venda_liquida);

        if (this.mostrar_previsao) {
          let dado_empresa_previsao = {
            name: 'Previsão de venda',
            data: []
          };

          for (let i = 0; i < this.dados_vendas.length; i++) {
            dado_empresa_previsao.data.push(this.dados_vendas[i].previsao_vendas);
          }

          dados_colunas_vendas_devolucoes.push(dado_empresa_previsao);
        }

        for (let i = 0; i < dados_colunas_vendas_devolucoes.length; i++) {
          for (let j = 0; j < dados_colunas_vendas_devolucoes[i].data.length; j++) {
            dados_colunas_vendas_devolucoes[i].data[j] = dados_colunas_vendas_devolucoes[i].data[j].split('.').join('');
            dados_colunas_vendas_devolucoes[i].data[j] = dados_colunas_vendas_devolucoes[i].data[j].split(',').join('.');
            dados_colunas_vendas_devolucoes[i].data[j] = parseFloat(dados_colunas_vendas_devolucoes[i].data[j]);
          }
        }

        /* SEMPRE POR ÚLTIMO */
        /* Series são os dados das barras do gráfico */
        this.series_vendas_devolucoes = dados_colunas_vendas_devolucoes;
      },

      trocarAba(botao, nova_aba) {
        let tablinks = document.getElementsByClassName('tablink');        
        for (let i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(' active', '');
        }

        this.aba_selecionada = nova_aba;
        document.getElementById(botao).className += ' active';
      },

      getLocalStorageId(data_inicial, data_final, empresas_ids) {
        return (
          'acompanhamento-vendas-dados' +
          data_inicial +
          'ate' +
          data_final +
          empresas_ids.join(',')
        )
      },

      existemValores() {
        if ((this.total_geral_vendas + this.total_geral_devolucoes) > 0) {
          return true;
        }

        return false;
      },

      nPadraoReais(numero, casas_decimais = 2) {
        return Biblioteca.nPadraoReais(numero, casas_decimais);
      }
    },

    created() {
      let elem = document.documentElement;
      elem.addEventListener(
        'fullscreenchange', 
        ()=> {
          this.tela_cheia = !this.tela_cheia;
          if (this.tela_cheia) {
            this.class_div_tabela = '';
          }
        }
      );
    },

    mounted() {
      this.data_inicial = Biblioteca.fDataInternacional(new Date());
      this.data_final = Biblioteca.fDataInternacional(new Date());

      this.buscarAcompanhamentoVendas(false);
      
      setInterval(
        () => {
          this.buscarAcompanhamentoVendas(true);
        }, 
        300000
      );
      
      let botaoDados = this.$refs.botaoDados;
      botaoDados.click();
    }
  }
</script>

<style>
  .empresas-selecionadas{
    font-size: 14px; 
    border-radius:15px;
    box-shadow: #ddd 1px 1px 1px 1px; 
    padding:10px!important;
  }
  
  .card-vendas{
    background-color: #ebebeb;
    border: 2px solid #ebebeb;
    padding: 10px;
    border-radius: 20px;
  }

  .botao-tipo-pesquisa {
    padding: 5px 0 5px 0; 
    width: 98%;
    border-radius: 20px;
    outline: 0;
    background-image: linear-gradient(to right, #f1f1f1, #f1f1f1);
    color: #000000;
    border: 1px solid #aaaaaa;
    cursor: pointer;
  }

  .botao-tipo-pesquisa-selecionado {
    background-image: linear-gradient(to right, #9c1d1c, #691212);
    color: #ffffff;
    border: 1px solid #95eee5;
    border: 1px solid #cccccc;
  }

  .animacao-div{
    position: relative;
    -webkit-animation-name: animacao; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 1s; /* Safari 4.0 - 8.0 */
    animation-name: animacao;
    animation-duration: 1s;
  }

  .div-tela-cheia{
    padding: 16px 8px 8px !important;
  }

  .div-tela-cheia:not(:root):-webkit-full-screen::backdrop{
    background: white !important;
  }

  .periodo{
    border-radius: 4px;
    border: 1px solid #da0908;
    margin: 10px 0;
  }

  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes animacao {
    100% {left:0px; top:0px;}
    0% {left:100%; top:0px;}    
  }

  /* Standard syntax */
  @keyframes animacao {
    100% {left:0px; top:0px;}
    0% {left:100%; top:0px;}  
  }

  #chart {
    max-width: 900px;
    margin: 35px auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/AcompanhamentoVendas.vue